/* eslint-disable jsx-a11y/anchor-is-valid */
// @ts-nocheck
import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../../../../../_metronic/helpers'
import {User} from '../../core/_models'

type Props = {
  user: User
}

const UserInfoCell: FC<Props> = ({user}) => (
  <div className='d-flex align-items-center'>
    {/* begin:: Avatar */}
    <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
      <a href='#'>
        {user.avatar ? (
          <div className='symbol-label'>
            <img src={toAbsoluteUrl(`/media/${user.avatar}`)} alt={user.name} className='w-100' />
          </div>
        ) : (
          <div
            className={clsx(
              'symbol-label fs-3',
              `bg-light-${user?.name[0]}`,
              `text-${user?.name[0]}`
            )}
          >
            {/* {user.initials?.label} */}
            {user?.name[0]}
          </div>
        )}
      </a>
    </div>
    <div className='d-flex flex-column'>
      <a href='#' className='text-gray-800 text-hover-primary mb-1'>
        {user.name ? formatName(user.name) : ''}
      </a>
      <span
        style={{
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          maxWidth: '160px',
          whiteSpace: 'nowrap',
        }}
      >
        {user?.email ? user?.email : ''}
      </span>
    </div>
  </div>
)

const formatName = (name) => {
  if (name.length > 30) {
    return name.slice(0, -5) + '...'
  } else {
    return name
  }
}

export {UserInfoCell}
